import React from "react";
import PropTypes from "prop-types";
import PortalDropdown, { DropdownMenuItem } from "views_shared/app/javascript/components/PortalDropdown";

// Figma's product card for a card-layout Represents tab: <RepresentRow>'s row plus price and description.
function RepresentCard({ row, onRemove = null }) {
  return (
    <div className="represent-card border border-neutral-20 rounded-3 d-flex flex-column">
      <a href={row.href} className="represent-card-image rounded-1 bg-neutral-10" aria-hidden="true" tabIndex={-1}>
        {row.imageUrl ? (
          <img src={row.imageUrl} alt="" className="w-100 h-100 rounded-1" />
        ) : (
          <span className="d-flex w-100 h-100 align-items-center justify-content-center text-neutral-50">
            <i className="fa-solid fa-box-open fa-2x" />
          </span>
        )}
      </a>
      <div className="d-flex align-items-center gap-1 mt-1">
        {row.subtitleCompanyHref ? (
          <a href={row.subtitleCompanyHref} className="paragraph-sm text-neutral-70 text-truncate">
            {row.subtitleCompanyName}
          </a>
        ) : (
          <span className="paragraph-sm text-neutral-70 text-truncate">{row.subtitleCompanyName}</span>
        )}
        {onRemove && (
          <div className="represent-card-menu ms-auto">
            <PortalDropdown
              toggleAriaLabel={`More actions for ${row.title}`}
              toggleIcon="fa-solid fa-ellipsis-vertical"
              toggleClassName="btn btn-secondary btn-icon rounded-2 text-primary-60 border-0 shadow-none"
            >
              <DropdownMenuItem icon="fa-solid fa-trash" label="Stop representing" onClick={() => onRemove(row)} />
            </PortalDropdown>
          </div>
        )}
      </div>
      <a href={row.href} className="paragraph-sm fw-medium text-neutral-100 text-decoration-none mt-1">
        {row.title}
      </a>
      {row.price != null && row.price !== "" && <div className="fw-medium text-neutral-100">${row.price}</div>}
      {row.description && (
        <p className="represent-card-description paragraph-sm text-neutral-70 mt-2 mb-0">{row.description}</p>
      )}
      <div className="mt-auto pt-3">
        <a href={row.href} className="btn btn-outline-secondary btn-sm w-100">
          View Product
        </a>
      </div>
    </div>
  );
}

RepresentCard.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    href: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitleCompanyName: PropTypes.string,
    subtitleCompanyHref: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    description: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func,
};

export default RepresentCard;
